export default "__VITE_ASSET__CgYjPqdi__"